import type { CustomerLanguage } from "@/lib/customer-language";

const MATCHING_COPY = {
  en: {
    personA: "Person A",
    personB: "Person B",
    nextPersonB: "Next: Enter Person B",
    calculate: "Calculate Gun Milan",
    change: "Change",
    loading: "Calculating Ashtakoot Gun Milan...",
    loadingDetail: "Generating kundalis and matching all 8 kootas",
    genericError: "Something went wrong",
    detailedError: "Failed to generate detailed report",
    compatibility: "compatibility",
    moon: "Moon",
    nakshatra: "Nakshatra",
    lagna: "Lagna",
    kootaBreakdown: "Ashtakoot (8 Koota) Breakdown",
    mangalStatus: "Mangal Dosha Status",
    mangalMeaning: "What does Mangal Dosha mean for this match?",
    recommendation: "Recommendation",
    deeperTitle: "Want Deeper Insights?",
    deeperBody:
      "Get Navamsha (D9) chart analysis, Dasha compatibility for the next 5 years, Dosha cross-check, and personalised upay recommendations.",
    deeperLoading: "Analysing charts...",
    deeperCta: "Get Detailed Report",
    navamshaAnalysis: "Navamsha Analysis",
    dashaCompatibility: "Dasha Compatibility",
    doshaCrosscheck: "Dosha Cross-Check",
    upayRecommendations: "Upay Recommendations",
    comprehensiveCompatibility: "Comprehensive Compatibility",
    challengingPeriods: "Challenging Periods Ahead",
    recommendedUpay: "Recommended Upay",
    recommendedPujaItems: "Recommended Puja Items",
    pujaItemsBody:
      "Based on the dosha analysis, these sacred products can help harmonise the planetary energies for this couple.",
    view: "View",
    generatingPdf: "Generating PDF...",
    downloadPdf: "Download PDF Report",
    fullReport: "Get Full Kundali Reading →",
    matchAnother: "Match Another Pair",
  },
  hi: {
    personA: "Pehli kundali",
    personB: "Doosri kundali",
    nextPersonB: "Agla: doosri kundali bharein",
    calculate: "Gun Milan calculate karein",
    change: "Badlein",
    loading: "Ashtakoot Gun Milan calculate ho raha hai...",
    loadingDetail: "Dono kundali aur sabhi 8 koota match ho rahe hain",
    genericError: "Kuch theek nahi chala. Dobara koshish karein.",
    detailedError: "Detailed report nahi ban paayi. Dobara koshish karein.",
    compatibility: "match",
    moon: "Chandra",
    nakshatra: "Nakshatra",
    lagna: "Lagna",
    kootaBreakdown: "Ashtakoot ke 8 Koota",
    mangalStatus: "Mangal Dosh status",
    mangalMeaning: "Is match ke liye Mangal Dosh ka kya matlab hai?",
    recommendation: "Jyotish guidance",
    deeperTitle: "Match ko aur gehra samjhein",
    deeperBody:
      "Navamsha (D9), agle 5 saal ki dasha compatibility, dosha cross-check aur personalised upay dekhein.",
    deeperLoading: "Dono kundali analyse ho rahi hain...",
    deeperCta: "Detailed Report dekhein",
    navamshaAnalysis: "Navamsha Analysis",
    dashaCompatibility: "Dasha Compatibility",
    doshaCrosscheck: "Dosha Cross-Check",
    upayRecommendations: "Upay Recommendations",
    comprehensiveCompatibility: "Complete Compatibility",
    challengingPeriods: "Aage ke challenging periods",
    recommendedUpay: "Suggested Upay",
    recommendedPujaItems: "Suggested Puja Items",
    pujaItemsBody:
      "Dosha analysis ke hisaab se ye puja items couple ki graha energy ko balance karne mein madad kar sakte hain.",
    view: "Dekhein",
    generatingPdf: "PDF ban rahi hai...",
    downloadPdf: "PDF Report download karein",
    fullReport: "Poori Kundali Reading dekhein →",
    matchAnother: "Doosra match karein",
  },
} as const;

export function matchingCopy(language: CustomerLanguage) {
  return MATCHING_COPY[language];
}
